/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="m14.0605.4415.2608.1264.357.2048a5.0128 5.0128 0 0 1 1.4093 1.3272l.1805.2703 6.9791 13.9909c1.4491 2.3322.7455 5.3992-1.5898 6.8673a5.0323 5.0323 0 0 1-2.3239.7591L18.9788 24H5.0206C2.2373 24 0 21.7496 0 18.996c0-.8141.1992-1.6145.5787-2.3325l.1736-.3024 6.979-13.9909C9.065.2242 11.7828-.5836 14.0606.4415Zm-4.281 2.916-.0985.142-6.9774 13.9818-.1357.2336A2.7415 2.7415 0 0 0 2.25 18.996c0 1.4419 1.1162 2.6297 2.5429 2.7448l.2277.0092 13.879.0014.2755-.0083a2.7808 2.7808 0 0 0 1.2848-.4196c1.2171-.765 1.6301-2.3169.9922-3.5691l-.2183-.3889L14.316 3.498l-.0583-.089c-.1668-.2332-.369-.4389-.5591-.5858l-.1395-.0987-.2841-.164-.153-.0735-.2097-.0834c-1.1348-.3957-2.4102-.0095-3.1328.9538ZM12 16.6932c.6312 0 1.1429.4844 1.1429 1.0819 0 .5976-.5117 1.0819-1.1429 1.0819s-1.1429-.4843-1.1429-1.0819c0-.5975.5117-1.0819 1.1429-1.0819Zm0-9.8362c.9468 0 1.7143.7266 1.7143 1.6229 0 .0365-.0013.0726-.0038.1085l-.5676 5.941c0 .5975-.5117 1.0819-1.1429 1.0819-.5861 0-1.0692-.4176-1.1352-.9557l-.0077-.1262-.5714-5.9413.0045-.027-.0045-.0812c0-.8365.6686-1.5252 1.5275-1.6133L12 6.857Z"
  />,
  'MenuWarning'
);
